import React from 'react';
import { Grid } from '@mui/material';

export const CourseEditLayout = ({ children }) => (
  <Grid container spacing={4} sx={{ p: 2 }}>{children}</Grid>
);

export const CourseEditColumn = ({ children }) => (
  <Grid item xs={12} md={6}>{children}</Grid>
);

export const CourseEditSection = ({ children }) => (
  <Grid item xs={12}>{children}</Grid>
);
